'use strict';

module.exports = /*@ngInject*/ ["$cookies", "ConfigService", function ($cookies, ConfigService) {
    var service = this;

    // Stateless CSRFFilter, based on https://blog.jdriven.com/2014/10/stateless-spring-security-part-1-stateless-csrf-protection/
    // The advantage of being stateless: no server stored token necessary.

    // generate a fancy random token, losely after https://gist.github.com/jed/982883
    function b(a) {
        return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e16] + 1e16).replace(/[01]/g, b)
    }

    service.request = function(config) {
        // put a new random secret into our CSRF-TOKEN Cookie before each request
        $cookies.put('XSRF-TOKEN', b(), { secure: ConfigService.get('secureCookies') });
        return config;
    };
}];